import { addStateReset } from "common/reducer/addStateReset";
import type { UploadMapFulfilledAction } from "domains/createMapDetail/actionTypes";
import { CreateMapTypes } from "domains/createMapDetail/actionTypes";
import { TopicDetailType } from "domains/topicDetail/actionTypes";
import { TransformationMapActionType } from "domains/transformationMap/actionTypes";
import { addUserChangeReset } from "entities/user/utils";

export const addTopicSelectionReset = <T, A extends { type: string }>(
  reducer: (state: T, action: A) => T,
  initialState: T,
) =>
  addStateReset(TopicDetailType.INIT, TransformationMapActionType.SET_EDIT_MODE)(
    addUserChangeReset(reducer, initialState),
    initialState,
  );

export const addUserOrMapChangeReset = <T extends Partial<Record<string, object[]>>, A extends { type: string }>(
  reducer: (state: T, action: A) => T,
  initialState: T,
) => addMapEditReset(addUserChangeReset(reducer, initialState));

const addMapEditReset =
  <T extends Partial<Record<string, object[]>>, A extends { type: string }>(reducer: (state: T, action: A) => T) =>
  (state: T, action: A) => {
    if (!actionIsMapUploadFulfilled(action)) return reducer(state, action);
    const { [action.payload.id]: _, ...newState } = state;
    return newState as T;
  };

const actionIsMapUploadFulfilled = (action: { type: string }): action is UploadMapFulfilledAction =>
  action.type === (CreateMapTypes.UPLOAD_FULFILLED as string);
